export default "__VITE_ASSET__c08c3559__"